export const getConversionData = () => {
    return {
        entrypage: sessionStorage?.getItem('entrypage') || '',
        pages: JSON.stringify(sessionStorage?.getItem('pages')) || '',
        entrydate: sessionStorage?.getItem('entrydate') || '',
        utm_campaign: sessionStorage?.getItem('utm_campaign') || '',
    }
}